import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import SearchAllTests from '../components/Common/SearchAllTests'

const Search = () => {
  return (
    <>
        <Navbar />
        <SearchAllTests />
    </>
  )
}

export default Search